import { useState, useEffect } from 'react'

import { getMs } from '@/helpers'


export const useDebounce = <T,>(
  value: T,
  delay = getMs('300ms'),
) => {
  const [ debounced, setDebounced ] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [ value, delay ])

  return debounced
}
